var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.65,168.23H136.87V143.08h18.78Zm-36.27,0H100.59V143.08h18.79Zm-36.28,0H64.32V143.08H83.1ZM140.75,106v6.61M128.45,106v6.61M116.13,106v6.61M104.47,106v6.61M92.17,106v6.61M79.86,106v6.61m29.79-83.38v22.5m-69.3,74.12v54.27m138.61,0V125.88m-23.31-31.1v30.44M64.32,94.11v31.11m-29.8,55.59H185.44M34.52,125.22H185.44M57.84,94.11H161.48m-90-2.64c0-21.93,17.4-39.71,38.87-39.71s38.86,17.78,38.86,39.71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/TEMPLE.409614b14a842187b4c3b1e03e2a69eb.svg";
export { ForwardRef as ReactComponent };